// src/locales/manage-en.ts
export default {
  manage: {
    dashboard: {
      title: "Dashboard",
      subtitle: "Monitor key metrics and activities",
      protectionScore: "Protection Score",
      activeLicenses: "Active Licenses",
      currentViolations: "Current Violations",
      monthlyRevenue: "Monthly Revenue",
      revenueChart: "Revenue Chart",
      recentViolations: "Recent Violations",
      viewAll: "View All",
      protectionMeasures: "Protection Measures",
      active: "Active",
      inactive: "Not Activated",
      expiringContracts: "Expiring Contracts",
      days: "days"
    },

    catalog: {
      title: "Manage Content Catalog",
      createNew: "Register New Work",
      search: "Search works...",
      filter: "Filter",
      apply: "Apply",
      sortBy: "Sort by",
      showing: "Showing",
      of: "of",
      items: "items",
      noWorks: "No works found",
      createWorkMessage: "Register a new work or change your filters.",
      deleteConfirmation: "Confirm Work Deletion",
      deleteWarning: "This action cannot be undone. All information related to this work will be permanently deleted.",
      confirmDelete: "Confirm Delete",
      cancel: "Cancel",
      processing: "Processing...",

      filters: {
        contentKind: "Content Type",
        allTypes: "All Types",
        image: "Image",
        audio: "Audio",
        video: "Video",
        text: "Text",
        status: "Status",
        allStatuses: "All Statuses",
        approved: "Approved",
        pending: "Pending",
        rejected: "Rejected",
        draft: "Draft",
        other: "Other"
      },

      sort: {
        title: "Work Title",
        registrationDate: "Registration Date",
        licenseCount: "License Count",
        viewCount: "View Count",
        protectionScore: "Protection Score"
      },

      view: {
        grid: "Grid View",
        list: "List View"
      },

      details: {
        registration: "Registration",
        protection: "Protection",
        licenses: "licenses",
        views: "views",
        actions: {
          edit: "Edit",
          renew: "Renew",
          cancel: "Cancel",
          approve: "Approve",
          reject: "Reject",
          view: "View"
        },

        days: "days",
        noActiveContracts: "No active contracts found",
        noPendingContracts: "No pending contracts found",
        noContracts: "No contracts found",

        modal: {
          editTitle: "Edit Contract",
          renewTitle: "Renew Contract",
          cancelTitle: "Cancel Contract",
          warning: "Warning!",
          cancelWarning: "You are about to cancel contract",
          forWork: "for work",
          cancelWarningText: "This action cannot be undone. Are you sure you want to continue?",

          form: {
            contractId: "Contract ID",
            work: "Work",
            startDate: "Start Date",
            endDate: "End Date",
            licenseType: "License Type",
            usage: "Usage Purpose",
            value: "Contract Value",
            cancelReason: "Cancellation Reason",
            update: "Update",
            renew: "Renew",
            confirmCancel: "Confirm Cancellation",
            cancel: "Cancel"
          },

          licenseTypes: {
            standard: "Standard",
            premium: "Premium",
            extended: "Extended"
          },

          usageTypes: {
            commercial: "Commercial",
            marketing: "Marketing",
            editorial: "Editorial",
            personal: "Personal"
          }
        }
      },

      payments: {
        title: "Copyright Fee Payments",
        subtitle: "Manage and track payments for copyright licenses",
        search: "Search by work title, license ID...",
        filter: "Filter",
        export: "Export",

        filters: {
          allStatuses: "All Statuses",
          completed: "Completed",
          pending: "Pending",
          failed: "Failed"
        },

        table: {
          paymentId: "Payment ID",
          work: "Work",
          licenseId: "License ID",
          amount: "Amount",
          method: "Method",
          date: "Date",
          status: "Status",
          actions: "Actions"
        },

        status: {
          completed: "Completed",
          pending: "Pending",
          failed: "Failed",
          unknown: "Unknown"
        },

        methods: {
          bank_transfer: "Bank Transfer",
          credit_card: "Credit Card",
          e_wallet: "E-Wallet",
          other: "Other"
        },

        actions: {
          viewInvoice: "View Invoice",
          downloadInvoice: "Download Invoice"
        },

        summary: {
          title: "Payment Summary",
          totalPayments: "Total Payments",
          successfulPayments: "Successful Payments",
          pendingPayments: "Pending"
        },

        noPaymentsFound: "No payment data found"
      },

      violations: {
        title: "Legal Violations",
        subtitle: "Manage and process copyright violations",
        search: "Search by work title, owner or violator...",

        filters: {
          allStatuses: "All Statuses",
          detected: "Detected",
          notified: "Notified",
          underReview: "Under Review",
          confirmed: "Confirmed",
          rejected: "Rejected",
          legalAction: "Legal Action"
        },

        table: {
          work: "Work",
          platform: "Platform",
          violationType: "Violation Type",
          violator: "Violator",
          detectionTime: "Detection Time",
          severity: "Severity",
          status: "Status",
          actions: "Actions"
        },

        severity: {
          critical: "Critical",
          high: "High",
          medium: "Medium",
          low: "Low"
        },

        status: {
          detected: "Detected",
          notified: "Notified",
          underReview: "Under Review",
          confirmed: "Confirmed",
          rejected: "Rejected",
          legalAction: "Legal Action"
        },

        violationTypes: {
          unauthorized_usage: "Unauthorized Usage",
          deepfake: "Deepfake",
          impersonation: "Impersonation",
          contract_violation: "Contract Violation",
          other: "Other"
        },

        actions: {
          view: "View",
          confirm: "Confirm Violation",
          reject: "Reject Violation",
          legalAction: "Move to Legal Action"
        },

        modal: {
          title: "Violation Details",
          violationId: "Violation ID",
          status: "Status",
          violatedWork: "Violated Work",
          owner: "Owner",
          platform: "Platform",
          violationType: "Violation Type",
          severity: "Severity Level",
          detectionTime: "Detection Time",
          violationUrl: "Violation URL",
          violator: "Violator",
          evidence: "Evidence",
          actions: "Actions Taken",
          noActionsRecorded: "No actions recorded yet",
          close: "Close"
        },

        noViolationsFound: "No violations found"
      },
      legalEnforcement: {
        title: "Legal Enforcement",
        subtitle: "Manage legal actions to protect intellectual property rights",
        createNew: "Create New Action",
        search: "Search by title, case ID or party names...",

        filters: {
          allStatuses: "All Statuses",
          planned: "Planned",
          inProgress: "In Progress",
          completed: "Completed",
          cancelled: "Cancelled"
        },

        table: {
          caseId: "Case ID",
          title: "Title",
          actionType: "Action Type",
          parties: "Related Parties",
          executionDate: "Execution Date",
          priority: "Priority",
          status: "Status",
          actions: "Actions"
        },

        status: {
          planned: "Planned",
          inProgress: "In Progress",
          completed: "Completed",
          cancelled: "Cancelled"
        },

        priority: {
          urgent: "Urgent",
          high: "High",
          medium: "Medium",
          low: "Low"
        },

        actionTypes: {
          warning: "Legal Warning",
          dmca: "DMCA Takedown",
          lawsuit: "Lawsuit",
          settlement_offer: "Settlement Offer",
          other: "Other"
        },

        actions: {
          view: "View",
          documents: "Documents",
          start: "Start Execution"
        },

        modal: {
          title: "Legal Action Details",
          tabs: {
            details: "Details",
            documents: "Documents",
            history: "History"
          },
          caseId: "Case ID",
          status: "Status",
          plaintiff: "Plaintiff",
          defendant: "Defendant",
          actionType: "Action Type",
          executionDate: "Execution Date",
          completionDate: "Completion Date",
          priority: "Priority Level",
          assignedTo: "Assigned To",
          linkedTo: "Linked To",
          violation: "Violation",
          dispute: "Dispute",
          description: "Description",
          documents: {
            title: "Documents",
            addDocument: "Add Document",
            noDocuments: "No documents found"
          },
          history: {
            title: "Action History",
            noActivities: "No activities recorded yet",
            createAction: "Created legal action",
            prepareDocuments: "Prepared and sent documents",
            completeAction: "Completed action"
          },
          close: "Close",
          startExecution: "Start Execution",
          markComplete: "Mark as Complete"
        },

        noActionsFound: "No legal actions found"
      },
      disputes: {
        title: "Legal Disputes",
        subtitle: "Manage and process disputes related to copyright",
        createNew: "Create New Dispute",
        search: "Search by title, case number or party names...",
        filters: {
          allStatuses: "All Statuses",
          pending: "Pending",
          active: "Active",
          resolved: "Resolved",
          cancelled: "Cancelled",
          appealed: "Appealed"
        },
        table: {
          caseNumber: "Case Number",
          title: "Title",
          parties: "Related Parties",
          disputeType: "Dispute Type",
          startDate: "Start Date",
          priority: "Priority",
          status: "Status",
          actions: "Actions"
        },
        disputeTypes: {
          copyright_dispute: "Copyright Dispute",
          contract_violation: "Contract Violation",
          other: "Other"
        },
        status: {
          pending: "Pending",
          active: "Active",
          resolved: "Resolved",
          cancelled: "Cancelled",
          appealed: "Appealed"
        },

        priority: {
          urgent: "Urgent",
          high: "High",
          medium: "Medium",
          low: "Low"
        },

        actions: {
          view: "View",
          edit: "Edit",
          documents: "Documents"
        },

        modal: {
          title: "Dispute Details",
          caseNumber: "Case Number",
          status: "Status",
          plaintiff: "Plaintiff",
          defendant: "Defendant",
          startDate: "Start Date",
          resolveDate: "Resolution Date",
          disputeType: "Dispute Type",
          priority: "Priority Level",
          assignedTo: "Assigned To",
          description: "Description",
          history: "Processing History",
          noActivities: "No activities recorded",
          close: "Close",
          edit: "Edit",
          updateStatus: "Update Status"
        },

        noDisputesFound: "No disputes found"
      },
      licenseRevocation: {
        title: "License Revocation",
        subtitle: "Manage and revoke usage licenses for violation cases",
        search: "Search by work title or licensee...",

        filters: {
          allStatuses: "All Statuses",
          active: "Active",
          pendingRevocation: "Pending Revocation",
          revoked: "Revoked"
        },

        table: {
          work: "Work",
          licensee: "Licensee",
          licenseType: "License Type",
          term: "Term",
          status: "Status",
          violations: "Violations",
          actions: "Actions"
        },

        licenseTypes: {
          basic: "Basic",
          premium: "Premium",
          enterprise: "Enterprise"
        },

        status: {
          active: "Active",
          pendingRevocation: "Pending Revocation",
          revoked: "Revoked"
        },

        term: {
          startDate: "Start Date",
          endDate: "End Date"
        },

        actions: {
          view: "View",
          revoke: "Revoke",
          undo: "Undo"
        },

        modal: {
          title: "Request License Revocation",
          requestingRevocation: "You are requesting to revoke the license for:",
          work: "Work",
          licensee: "Licensee",
          violations: "Number of Violations",
          reason: "Revocation Reason",
          reasonRequired: "Revocation Reason *",
          reasonPlaceholder: "Enter the reason for license revocation...",
          cancel: "Cancel",
          requestRevocation: "Request Revocation"
        },

        noLicensesFound: "No licenses found"
      },
      identityProtection: {
        title: "Identity Protection",
        subtitle: "Manage and protect your identity and content from violations and abuse",

        overview: {
          overallScore: "Overall Protection Score",
          protectionLevel: "Protection Level",
          identity: "Identity",
          content: "Content",
          detection: "Detection",
          currentAlerts: "Current Alerts",
          securityWeaknesses: "Security Weaknesses",
          safetyLevel: "Safety Level",
          issues: "issues",
          safe: "Safe",
          noWeaknesses: "No weaknesses detected",
          allProtectionsMeasuresWorking: "All protection measures are working properly",
          protectionStats: "Protection Statistics",
          worksProtected: "works",
          beingProtected: "Being protected",
          certificatesIssued: "certificates",
          issuedOnBlockchain: "Issued on blockchain",
          violations: "violations",
          resolved: "Resolved",
          scans: "scans",
          inPast7Days: "In the past 7 days"
        },

        tabs: {
          overview: "Overview",
          alerts: "Alerts",
          measures: "Protection Measures",
          scan: "Detection Scan"
        },

        alerts: {
          highAlerts: "High Alerts",
          mediumAlerts: "Medium Alerts",
          lowAlerts: "Low Alerts",
          viewAllAlerts: "View All Alerts",
          title: "All Alerts",
          filter: "Filter",
          markAsRead: "Mark as Read",
          detected: "Detected",
          platform: "Platform",
          level: "Level",
          viewDetails: "View Details",
          handleNow: "Handle Now",
          resolved: "Resolved"
        },

        measures: {
          identityProtectionMeasures: "Identity Protection Measures",
          measures: "Measures",
          status: "Status",
          effectiveness: "Effectiveness",
          active: "Active",
          activate: "Activate",
          notActivated: "Not Activated",
          manageMeasures: "Manage Protection Measures",
          addNew: "Add New Measure",
          description: "Description",
          turnOff: "Turn Off"
        },

        scan: {
          violationDetection: "Violation Detection Scan",
          scanInfo: "The system will automatically scan platforms to detect copyright and identity violations. You can also run manual scans at any time.",
          lastScan: "Last scan",
          quickScan: "Quick Scan",
          quickScanDesc: "Scan popular platforms to detect new violations",
          startQuickScan: "Start Quick Scan",
          comprehensiveScan: "Comprehensive Scan",
          comprehensiveScanDesc: "Deep scan across many platforms and websites (may take longer)",
          startComprehensiveScan: "Start Comprehensive Scan",
          scanOptions: "Scan Options",
          socialMedia: "Social Media (Facebook, Instagram, TikTok...)",
          videoSites: "Video Sites (YouTube, Vimeo...)",
          ecommerce: "E-commerce Sites",
          blogs: "Blogs and News Sites",
          deepfake: "Deepfake Detection",
          impersonation: "Find Impersonating Accounts",
          scanHistory: "Scan History",
          date: "Date",
          type: "Type",
          results: "Results",
          violations: "violations",
          autoScanConfig: "Automatic Scan Configuration",
          scanFrequency: "Scan Frequency",
          daily: "Daily",
          weekly: "Weekly",
          biweekly: "Bi-weekly",
          monthly: "Monthly",
          scanTime: "Scan Time",
          morning: "Morning (8:00)",
          afternoon: "Afternoon (14:00)",
          night: "Night (22:00)",
          autoSendTakedown: "Automatically send takedown requests for violations",
          saveConfig: "Save Configuration"
        },

        tips: {
          identityProtectionTips: "Identity Protection Tips",
          updateWorks: "Update Works Regularly",
          updateWorksDesc: "Updating metadata and information about your works helps improve detection and prevent violations.",
          activateAllMeasures: "Activate All Protection Measures",
          activateAllMeasuresDesc: "Activating all protection measures helps enhance the safety of your works and identity.",
          checkAlertsRegularly: "Check Alerts Regularly",
          checkAlertsRegularlyDesc: "Timely processing of alerts helps limit the impact of copyright and identity violations."
        }
      },

      aiScan: {
        title: "AI Scan and Violation Detection",
        subtitle: "Use AI to scan and detect copyright violations across digital platforms",

        stats: {
          aiModelInUse: "AI Model in Use",
          accuracy: "Accuracy",
          configure: "Configure",
          lastScan: "Last Scan",
          totalScans: "Total Scans",
          totalViolationsDetected: "Total Violations Detected",
          avgScanTime: "Average Scan Time",
          minutes: "minutes"
        },

        newScan: {
          startNewScan: "Start New Scan",
          scanning: "Scanning...",
          scanNote: "The scanning process may take from a few minutes to several hours depending on the number of works and scan settings.",
          scanCompleted: "Scan Completed!",
          scanCompletedMessage: "The scan process has completed, detecting {count} potential violations.",
          scanAgain: "Scan Again",

          scanPlatform: "Scan Platform",
          allPlatforms: "All Platforms",
          facebook: "Facebook",
          youtube: "YouTube",
          instagram: "Instagram",
          tiktok: "TikTok",
          websites: "Websites",

          scanDepth: "Scan Depth",
          quick: "Quick Scan (less accurate)",
          standard: "Standard (balance between time and accuracy)",
          deep: "Deep Scan (most accurate, but takes longer)",

          violationType: "Violation Type",
          allViolationTypes: "All Violation Types",
          unauthorizedUsage: "Unauthorized Usage",
          deepfake: "Deepfake",
          impersonation: "Impersonation",
          contractViolation: "Contract Violation",

          additionalOptions: "Additional Options",
          enableDeepfake: "Enable deepfake detection",
          enableImpersonation: "Enable identity impersonation detection",

          startScan: "Start Scan"
        },

        detectionResults: {
          title: "Detection Results",
          filter: "Filter",
          exportReport: "Export Report",
          downloadCsv: "Download CSV",
          work: "Work",
          platform: "Platform",
          violationType: "Violation Type",
          severity: "Severity",
          similarity: "Similarity",
          detectionTime: "Detection Time",
          actions: "Actions",
          view: "View",
          report: "Report"
        },

        aiModels: {
          availableModels: "Available AI Models",
          modelName: "Model Name",
          accuracy: "Accuracy",
          lastUpdate: "Last Update",
          status: "Status",
          active: "Active",
          inactive: "Inactive",
          inUse: "In Use",
          select: "Select"
        },

        autoScan: {
          schedule: "Automatic Scan Schedule",
          frequency: "Scan Frequency",
          daily: "Daily",
          weekly: "Weekly",
          biweekly: "Bi-weekly",
          monthly: "Monthly",
          scanDepth: "Scan Depth",
          dayOfWeek: "Day of Week",
          monday: "Monday",
          tuesday: "Tuesday",
          wednesday: "Wednesday",
          thursday: "Thursday",
          friday: "Friday",
          saturday: "Saturday",
          sunday: "Sunday",
          time: "Time",
          timeHint: "Choose a time with low system load",
          sendNotification: "Send notification when violations are detected",
          autoCreateReport: "Automatically create violation reports",
          updateSchedule: "Update Schedule"
        },

        guide: {
          title: "Guide",
          manualVsAuto: "Manual vs. Automatic Scans",
          manualVsAutoDesc: "Manual scans give you more control, while automatic schedules provide continuous monitoring.",
          scanDepth: "Scan Depth",
          scanDepthDesc: "Deep scans provide the most accurate results but take longer. Quick scans are suitable for daily checks.",
          processingResults: "Processing Results",
          processingResultsDesc: "You should carefully review each detected violation to ensure accuracy before taking legal actions."
        }
      },

      system: {
        title: "System Administration",
        subtitle: "Configure and monitor the Vietrro system",

        dashboard: {
          serverStatus: "Server Status",
          lastUpdate: "Last update",
          online: "Online",
          offline: "Offline",
          uptime: "Uptime",
          dataBackup: "Data Backup",
          apiRequests: "API Requests",
          today: "Requests today",
          activeUsers: "Active Users",
          onlineUsers: "Users online"
        },

        resources: {
          title: "System Resources",
          cpuUsage: "CPU Usage",
          memoryUsage: "Memory Usage",
          diskUsage: "Disk Usage"
        },

        services: {
          title: "Service Status",
          webServer: "Web Server",
          database: "Database",
          apiService: "API Service",
          emailService: "Email Service",
          backupService: "Backup Service",
          aiDetection: "AI Detection"
        },

        backups: {
          title: "Backup Management",
          recentBackups: "Recent Backups",
          createBackup: "Create New Backup",
          backupId: "ID",
          name: "Name",
          time: "Time",
          size: "Size",
          status: "Status",
          actions: "Actions",
          download: "Download",
          newBackup: "Create New Backup",
          backupType: "Backup Type",
          fullBackup: "Full Backup",
          databaseOnly: "Database Only",
          filesOnly: "Files Only",
          userData: "User Data",
          description: "Description",
          backupInProgress: "Creating backup. Please wait...",
          cancel: "Cancel",
          processing: "Processing..."
        },

        settings: {
          title: "System Settings",
          general: "General Settings",
          systemName: "System Name",
          adminEmail: "Admin Email",
          sessionTimeout: "Session Timeout (minutes)",
          defaultLanguage: "Default Language",
          vietnamese: "Vietnamese",
          english: "English",
          security: "Security Settings",
          require2FA: "Require 2FA for admins",
          yes: "Yes",
          no: "No",
          minPasswordLength: "Minimum Password Length",
          maxLoginAttempts: "Maximum Login Attempts",
          accountLockTime: "Account Lock Time (minutes)",
          saveSettings: "Save Settings"
        },

        logs: {
          title: "System Logs",
          all: "All Logs",
          error: "Error",
          warning: "Warning",
          info: "Information",
          time: "Time",
          level: "Level",
          module: "Module",
          content: "Content",
          ip: "IP",
          exportLogs: "Export Logs",
          previous: "Previous",
          next: "Next"
        }
      },

      apiManagement: {
        title: "API Management",
        subtitle: "Manage API keys and monitor usage",
        createKey: "Create API Key",
        search: "Search...",

        tabs: {
          keys: "API Keys",
          usage: "Usage"
        },

        keysTable: {
          name: "Name",
          key: "API Key",
          creator: "Creator",
          status: "Status",
          created: "Created",
          expires: "Expires",
          lastUsed: "Last Used",
          actions: "Actions"
        },

        usageTable: {
          date: "Date",
          apiKey: "API Key",
          requests: "Requests",
          success: "Success",
          errors: "Errors",
          responseTime: "Response Time (ms)",
          dataTransferred: "Data Transferred (MB)"
        },

        status: {
          active: "Active",
          inactive: "Inactive",
          revoked: "Revoked"
        },

        filter: {
          today: "Today",
          yesterday: "Yesterday",
          last7Days: "Last 7 days",
          last30Days: "Last 30 days",
          allApiKeys: "All API Keys"
        },

        modal: {
          createNewKey: "Create New API Key",
          editKey: "Edit API Key",
          revokeKey: "Revoke API Key",
          warning: "Warning!",
          revokeWarning: "You are about to revoke API key",
          irreversibleAction: "This action is irreversible and will make all requests using this key stop working.",
          confirmContinue: "Are you sure you want to continue?",
          keyCreated: "Your API key has been created successfully!",
          saveKeyWarning: "This is the only time your API key will be displayed. Save it now.",
          keySaved: "I've saved my API key",

          form: {
            keyName: "API Key Name",
            keyNameHelp: "Name it to easily identify the purpose of this API key",
            requestLimit: "Request Limit",
            term: "Term",
            days30: "30 days",
            days90: "90 days",
            days180: "180 days",
            year1: "1 year",
            year2: "2 years",
            accessPermissions: "Access Permissions",
            readPermission: "Read Permission (GET)",
            createPermission: "Create Permission (POST)",
            updatePermission: "Update Permission (PUT/PATCH)",
            deletePermission: "Delete Permission (DELETE)",
            notes: "Notes (optional)",
            cancel: "Cancel",
            create: "Create API Key",
            update: "Update",
            revoke: "Revoke API Key"
          }
        },

        info: {
          title: "API Information",
          securityWarning: "API keys are secret and should not be shared publicly. Protect your API keys like passwords.",
          description: "Vietrro's API allows you to integrate copyright management features into your application.",
          documentation: "Full API documentation is available at",
          viewDocs: "View API Documentation"
        },

        limits: {
          title: "Usage Limits",
          packageLimits: "Package Limits",
          basic: "Basic Package",
          professional: "Professional Package",
          enterprise: "Enterprise Package",
          requestsPerDay: "requests/day",
          currentUsage: "Current Usage",
          today: "Today"
        }
      },

      admin: {
        permissions: {
          title: "User & Permission Management",
          subtitle: "Manage user accounts and system permissions",
          search: "Search...",
          addUser: "Add User",

          tabs: {
            users: "Users",
            roles: "Roles & Permissions"
          },

          userTable: {
            id: "ID",
            name: "Name",
            email: "Email",
            role: "Role",
            status: "Status",
            created: "Created",
            lastLogin: "Last Login",
            actions: "Actions"
          },

          roleTable: {
            id: "ID",
            roleName: "Role Name",
            description: "Description",
            userCount: "User Count",
            permissions: "Permissions",
            actions: "Actions"
          },

          status: {
            active: "Active",
            inactive: "Inactive",
            suspended: "Suspended"
          },

          roles: {
            admin: "Administrator",
            staff: "Staff",
            right_owner: "Rights Owner",
            licensee: "Licensee",
            legal: "Legal",
            monitor: "Monitor"
          },

          overview: {
            title: "User Overview",
            totalUsers: "Total Users",
            active: "Active",
            inactive: "Inactive",
            newUsers: "New Users (Last 30 days)"
          },

          distribution: {
            title: "User Distribution by Role",
            users: "users"
          },

          modal: {
            addUser: "Add New User",
            editUser: "Edit User",
            addRole: "Add New Role",
            editRole: "Edit Role",

            form: {
              fullName: "Full Name",
              email: "Email",
              role: "Role",
              selectRole: "-- Select Role --",
              status: "Status",
              active: "Active",
              inactive: "Inactive",
              suspended: "Suspended",
              password: "Password",
              confirmPassword: "Confirm Password",
              notes: "Notes",
              roleName: "Role Name (Display)",
              systemName: "Role Name (System)",
              systemNameHelp: "Use only lowercase letters, no accents and underscores",
              description: "Description",
              systemPermissions: "System Permissions",
              allPermissions: "All Permissions (Admin)",
              contentManagement: "Content Management",
              userManagement: "User Management",
              licenseManagement: "License Management",
              legalManagement: "Legal Management",
              monitoringReporting: "Monitoring and Reporting",
              others: "Others",
              cancel: "Cancel",
              add: "Add",
              update: "Update"
            }
          }
        },

        logs: {
          title: "System Activity Logs",
          subtitle: "View and manage system activity logs",
          search: "Search by content, user...",

          filters: {
            allLevels: "All Levels",
            error: "Error",
            warning: "Warning",
            info: "Info",
            debug: "Debug",
            allModules: "All Modules"
          },

          actions: {
            filter: "Filter",
            export: "Export"
          },

          table: {
            id: "ID",
            timestamp: "Timestamp",
            level: "Level",
            module: "Module",
            user: "User",
            action: "Action",
            ip: "IP",
            actions: "Actions"
          },

          loading: "Loading data...",
          noLogsFound: "No matching logs found",
          noLogs: "No logs yet",

          summary: {
            title: "Log Overview",
            totalLogs: "Total Logs",
            errors: "Errors",
            warnings: "Warnings",
            info: "Information"
          },

          management: {
            title: "Log Management",
            description: "System logs are stored for a certain period of time for audit and troubleshooting purposes.",
            downloadLogs: "Download Logs",
            deleteOldLogs: "Delete Old Logs"
          }
        }
      },

      licensePurchase: {
        title: "Purchase License",
        subtitle: "Choose and purchase a license that fits your needs",

        workInfo: {
          title: "Work Information",
          author: "Author",
          type: "Type",
          category: "Category",
          rating: "Rating",
          purchases: "Purchases",
          imageCount: "Image Count",
          formats: "Formats",
          resolution: "Resolution",
          createdDate: "Created Date"
        },

        license: {
          chooseLicense: "Choose License",
          licenseType: "License Type",
          licenseTerm: "License Term",
          agreement: "I agree to the",
          termsAndConditions: "terms and conditions",
          ofLicense: "of the license",
          buyLicense: "Buy License"
        },

        payment: {
          title: "Payment Information",
          licenseType: "License Type",
          term: "Term",
          licensePrice: "License Price",
          vat: "VAT (10%)",
          totalPayment: "Total Payment",
          paymentMethod: "Payment Method",
          creditCard: "Credit Card / Debit Card",
          bankTransfer: "Bank Transfer",
          support: "Support",
          supportText: "If you need assistance or have questions about licensing, please contact us.",
          requestSupport: "Request Support"
        },

        important: {
          title: "Important Note",
          notice: "The license will be effective immediately after payment is completed. You can download the work and start using it right away."
        },

        termsModal: {
          title: "License Terms and Conditions",
          licenseTerms: "Vietrro Content License",
          termsAgreement: "By purchasing and using the license, you agree to the following terms and conditions:",
          scope: "Scope of Use",
          scopeDesc: "The scope of use depends on the type of license you choose. Each license type has different rights and limitations. You may only use the work within the scope specified in the license.",
          term: "Term",
          termDesc: "The license is valid for the specified period from the date of purchase. After expiration, you must stop using the work or renew the license.",
          intellectualProperty: "Intellectual Property",
          ipDesc: "The author retains intellectual property rights to the work. The license only grants usage rights, not ownership.",
          attribution: "Attribution Requirements",
          attributionDesc: "Unless otherwise specified in the license, you must acknowledge the author's name and the source of the work when using it.",
          restrictions: "Restrictions",
          restrictionsDesc: "You may not copy, redistribute, resell, rent, or transfer the license or work to third parties, unless specifically allowed in the license.",
          termination: "Termination",
          terminationDesc: "The license will automatically terminate if you violate any of its terms. In this case, you must immediately cease using the work.",
          indemnification: "Indemnification",
          indemnificationDesc: "You agree to indemnify the author and Vietrro in case of damages arising from improper use of the work.",
          agree: "I Agree"
        },

        successModal: {
          title: "License Purchase Successful",
          thankYou: "Thank you for purchasing a license!",
          successMessage: "The transaction has been processed successfully. Your license has been activated.",
          licenseCode: "License Code",
          downloadWork: "Download Work",
          viewLicense: "View License"
        }
      }
    }
  }
}; 
